module.exports = "newButton{margin-top:26px}form-group col-md-2{margin-top:26px}\n"